<template>
  <div class="pd70">
    <Nav v-if="!isPage('detail')"></Nav>
    <keep-alive>
      <a-locale-provider :locale="zh_CN">
        <router-view v-if="RouterShow"></router-view>
      </a-locale-provider>
    </keep-alive>
    <!--<a-back-top />-->
  </div>
</template>

<script>
import Nav from "./nav";
import { myMixin } from "@/mixins/tool.js";

export default {
  name: "mobile",
  mixins: [myMixin],
  components: {
    Nav,
  },
  data() {
    return {
      links: [],
    };
  },
  watch: {
    getAuth: {
      handler(val, oldval) {
        if (val != oldval) {
          this.setDataLinks();
        }
      },
      deep: true,
    },
    links: {
      handler(val, oldval) {
        if (val != oldval) {
          this.userLoaded();
        }
      },
      deep: true,
    },
  },
  methods: {
    async setDataLinks() {
      var self = this;
      await this.$axios
        .get(`${window.commonApi.INFOPLUS_URL}/me/positions`)
        .then((res) => {
          if (res.data.errno === 0) {
            let userProfile = res.data.entities.map(function (res) {
              return res.post.name;
            });
            if (userProfile.indexOf("教职工") > -1) {
              self.links = [
                {
                  uri: "",
                  name: "出访公示",
                  icon: "project",
                },
                {
                  uri: "",
                  name: "因公出访",
                  icon: "plane",
                },
              ];
            }
            if (
              userProfile.indexOf("本科生") > -1 ||
              userProfile.indexOf("研究生") > -1
            ) {
              self.links = [
                {
                  uri: "",
                  name: "项目列表",
                  icon: "project",
                },
                {
                  uri: "",
                  name: "项目公示",
                  icon: "plane",
                },
                {
                  uri: "",
                  name: "自主联系项目",
                  icon: "invite",
                },
                {
                  uri: "",
                  name: "国际学术会议参会项目",
                  icon: "pass",
                },
              ];
            }
          }
        })
        .catch((error) => {
          console.log(error); //请求失败返回的数据
        });
    },
    appsFilter: function (apps) {
      return apps.filter((item) => {
        return item.tags && item.tags.indexOf("WSXT") != -1;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/index.vue